import { request, toQuery } from './client';
import type { PaginationParams } from './client';

export type DaySchedule = {
	repeat: boolean;
	start_time: string;
	end_time: string;
};

export type WeeklySchedule = {
	sunday: DaySchedule;
	monday: DaySchedule;
	tuesday: DaySchedule;
	wednesday: DaySchedule;
	thursday: DaySchedule;
	friday: DaySchedule;
	saturday: DaySchedule;
};

export type Availability = {
	id: number;
	user_id: number;
	timezone: string;
	start_date: string;
	schedule: WeeklySchedule;
	is_program_specific: boolean;
	program_ids: number[];
	created_at: string;
};

export type AvailabilitiesListResponse = {
	availabilities: Availability[];
	total: number;
};

export type AvailabilityListParams = PaginationParams & {
	user_id?: number;
};

export type CreateAvailabilityData = {
	user_id?: number;
	start_date?: string;
	timezone?: string;
	schedule: Partial<Record<keyof WeeklySchedule, Partial<DaySchedule>>>;
};

export type UpdateAvailabilityData = Partial<CreateAvailabilityData> & {
	user_id?: number;
};

export type TimeSlot = {
	start_time: string;
	end_time: string;
	available: boolean;
};

export type AvailableDaysResponse = {
	available_days: number[]; // 0=Sunday .. 6=Saturday
};

export type SlotsResponse = {
	slots: TimeSlot[];
	duration_minutes: number;
};

export const availabilitiesApi = {
	list: (params?: AvailabilityListParams) =>
		request<AvailabilitiesListResponse>('/availabilities' + toQuery(params)),

	create: (data: CreateAvailabilityData) =>
		request<Availability>('/availabilities', { method: 'POST', data }),

	update: (id: number, data: UpdateAvailabilityData) =>
		request<Availability>(`/availabilities/${id}`, { method: 'PUT', data }),

	delete: (id: number) =>
		request<{ deleted: boolean }>(`/availabilities/${id}`, { method: 'DELETE' }),

	availableDays: (enrollmentId: number) =>
		request<AvailableDaysResponse>('/availabilities/available-days' + toQuery({ enrollment_id: enrollmentId })),

	slots: (enrollmentId: number, date: string) =>
		request<SlotsResponse>('/availabilities/slots' + toQuery({ enrollment_id: enrollmentId, date })),
};
